import apiService from './api';

export interface AiGlobalStatus {
  apiKeyConfigured: boolean;
  baseUrlConfigured: boolean;
  masterEnabled: boolean;
  breakerOpen: boolean;
  breakerOpenUntil: string | null;
  dailyBudgetUsd: number;
  spentTodayUsd: number;
  budgetExceeded: boolean;
  operational: boolean;
}

export interface AiQueueStatus {
  enabled: boolean;
  mode: string;
  intervalMinutes: number;
  batchSize: number;
  lastRunAt: string | null;
  lastResult: any | null;
  pending: number;
  processed: number;
  violations?: number;
  autoReplied?: number;
}

/** 🛡️ سیاست تماس — مسدودسازی فوری آیدی/شماره/لینک پیام‌رسان (مستقل از AI) */
export interface ContactPolicyStatus {
  enabled: boolean;
  blockRules: string[];
  strikeThreshold: number;
  strikeWindowHours: number;
  muteMinutes: number;
  total: number;
  last24h: number;
  mutedNow: number;
  offenders7d: number;
}

export interface AiStatusResponse {
  global: AiGlobalStatus;
  contactPolicy?: ContactPolicyStatus | null;
  queues: {
    chat: AiQueueStatus;
    products: AiQueueStatus;
    edits: AiQueueStatus;
    tickets: AiQueueStatus;
  };
}

export interface AiActivityItem {
  id: string;
  title: string;
  image?: string | null;
  sender?: string;
  senderIsSeller?: boolean;
  userId?: string;
  chatId?: string;
  /** فقط برای type=blocked: chat | seller_chat | review | review_reply | product | store */
  surface?: string;
  status: string;
  isVerified?: boolean;
  aiReview: any;
  createdAt: string;
}

export type AiActivityType = 'products' | 'edits' | 'chat' | 'tickets' | 'blocked';

export interface AiActivityResponse {
  items: AiActivityItem[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

class AiReviewService {
  private baseUrl = '/admin/ai-review';

  async getStatus(): Promise<AiStatusResponse> {
    const response: any = await apiService.get(`${this.baseUrl}/status`);
    return response?.data || response;
  }

  async getActivity(
    type: AiActivityType,
    page = 1,
    limit = 20,
    userId?: string
  ): Promise<AiActivityResponse> {
    const userQ = userId ? `&userId=${encodeURIComponent(userId)}` : '';
    const response: any = await apiService.get(
      `${this.baseUrl}/activity?type=${type}&page=${page}&limit=${limit}${userQ}`
    );
    return response?.data || response;
  }

  async runQueue(queue: 'chat' | 'products' | 'edits' | 'tickets'): Promise<{ message: string; data: any }> {
    const response: any = await apiService.post(`${this.baseUrl}/run/${queue}`, {});
    return { message: response?.message || '', data: response?.data };
  }
}

const aiReviewService = new AiReviewService();
export default aiReviewService;
